import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_report_query_run_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_hdr_guid: fromDatatype.GuidDataFieldInterface;
  prev_run_guid: fromDatatype.GuidDataFieldInterface;
  run_code: fromDatatype.VarcharDatatypeInterface;
  run_name: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  generated_sql_query: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_bi_report_query_run_hdr_RowClass
  implements bl_bi_report_query_run_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_hdr_guid: fromDatatype.GuidDataFieldInterface;
  prev_run_guid: fromDatatype.GuidDataFieldInterface;
  run_code: fromDatatype.VarcharDatatypeInterface;
  run_name: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  generated_sql_query: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
